import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { verifyEmailToken, resendVerificationEmail } from '../services/authenticationService';
import FlyLogo from '../assets/images/flyhi_logo_full.svg';

export default function EmailVerificationPage() {
    const [searchParams] = useSearchParams();
    const [status, setStatus] = useState('loading'); // loading | verified | expired | invalid | resent
    const [resending, setResending] = useState(false);

    useEffect(() => {
        const token = searchParams.get('token');
        if (!token) {
            setStatus('invalid');
            return;
        }
        verifyEmailToken(token).then((res) => {
            const s = res?.data?.status;
            if (s === 'VERIFIED') {
                
                setStatus('verified');
               
            } else if (s === 'EXPIRED') {
                setStatus('expired');
            }else if (s === 'VERIFIED_ALREADY') {
                setStatus('verified_already');
            } else {
                setStatus('invalid');
            }
        }).catch(() => setStatus('invalid'));
    }, []);

    async function handleResend() {
        setResending(true);
        await resendVerificationEmail();
        setResending(false);
        setStatus('resent');
    }

    return (
        <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 3, p: 4 }}>
            <img src={FlyLogo} alt="Fly Hi Finance" style={{ width: 80 }} />

            {status === 'loading' && (
                <>
                    <CircularProgress color="error" />
                    <Typography variant="h6" color="textSecondary">Verifying your email…</Typography>
                </>
            )}

            {status === 'verified' && (
                <>
                    <CheckCircleOutlineIcon sx={{ fontSize: 72, color: 'green' }} />
                    <Typography variant="h5" fontWeight="bold">Email Verified!</Typography>
                    <Typography color="textSecondary">Thank you for verifying your email, you can now proceed with your application.</Typography>
                    <Typography color="textSecondary">You can close this tab.</Typography>
                </>
            )}
            {status === 'verified_already' && (
                <>
                    <CheckCircleOutlineIcon sx={{ fontSize: 72, color: 'green' }} />
                    <Typography variant="h5" fontWeight="bold">Email Already Verified!</Typography>
                    <Typography color="textSecondary">Your email is verified already.</Typography>
                </>
            )}

            {status === 'expired' && (
                <>
                    <ErrorOutlineIcon sx={{ fontSize: 72, color: '#D32F2F' }} />
                    <Typography variant="h5" fontWeight="bold">Link Expired</Typography>
                    <Typography color="textSecondary" textAlign="center">
                        Your verification link has expired. <br />Please login & request a new verification email.
                    </Typography>
                    
                </>
            )}

            {status === 'resent' && (
                <>
                    <CheckCircleOutlineIcon sx={{ fontSize: 72, color: 'green' }} />
                    <Typography variant="h5" fontWeight="bold">Email Sent!</Typography>
                    <Typography color="textSecondary" textAlign="center">
                        A new verification link has been sent to your registered email address. Please check your inbox.
                    </Typography>
                </>
            )}

            {status === 'invalid' && (
                <>
                    <ErrorOutlineIcon sx={{ fontSize: 72, color: '#D32F2F' }} />
                    <Typography variant="h5" fontWeight="bold">Invalid Link</Typography>
                    <Typography color="textSecondary" textAlign="center">
                        This verification link is invalid. Please log in and request a new verification email.
                    </Typography>
                </>
            )}
        </Box>
    );
}
